import { useQueryClient } from "react-query";

export type ServerError = {
  message: string;
  details?: {
    key_value?: string;
  };
};

/**
 * @deprecated Use react-modal and trigger-signals instead.
 * More information can be found on Notion or ask the team on Slack.
 */
export class Popup {
  static popup_div_id = "ea-popup-root";
  static popup_div = document.getElementById(Popup.popup_div_id);

  static popupQueryClient() {
    const queryClient = useQueryClient();
    return queryClient;
  }

  /**
   * @param element - Takes in function returning the popup-element popuplated with its id. This guarantees
   * that the popup-container has an id. This is needed for removing the popup.
   */
  static present(element: (id: string) => JSX.Element, backshadow?: boolean, duration?: number) {
    const id = Popup._generateID();

    if (Popup.presentHandler) Popup.presentHandler(element(id), backshadow, duration);

    return id;
  }

  /**
   *  @abstract function for removing a popup.
   *  Initialized in PopupRoot so that they are added to the global popups-list in PopupRoot
   */
  static presentHandler: ((popup: JSX.Element, backshadow?: boolean, duration?: number, animated?: boolean) => void) | undefined = undefined;

  /**
   *  Removes popup with removeHandler (see below comments)
   *  @todo implement animation-support
   */
  static remove(id: string, animated: boolean = false, duration?: number) {
    //See comment on removeHandler below
    if (Popup.removeHandler) Popup.removeHandler(id, animated);
  }

  /**
   *  @abstract function for removing a popup.
   *  Initialized in PopupRoot such that the function can remove Popups from the
   *  global popup-list.
   */
  static removeHandler: ((id: string, animated?: boolean, duration?: number) => void) | undefined = undefined;

  /**
   *  @private
   *  @returns generated ID for popup in form 'popupXXXXXXXX...' where the Xs are numbers.
   *  Used as the 'key' for popup-elements.
   */
  static _generateID() {
    return "popup-" + Date.now();
  }
}

